import { IUserBundle, IWizard, IWizardExecution } from '@/modules/admin/workflows/types/wizard-types'
import { createQuery } from '../api/query'
import {
    APIUserBundleResponse,
    APIUserWizardBundleResponse,
    APIUserWizardResponse,
    APIWizardExecutionResponse,
    APIWizardResponse,
} from './types'

export const keyWizards = (arg: string) => [`/wizards`, arg]
export const useQueryWizards = createQuery<APIWizardResponse>({
    key: keyWizards,
    url: '/wizards',
})

export const keyWizard = (arg: string) => [`/wizard`, arg]
export const useQueryWizard = createQuery<IWizard>({
    key: keyWizard,
    url: '/wizard',
})

const keyWizardExecution = (arg: string) => [`/wizard/execution`, arg]
export const useQueryWizardExecution = createQuery<IWizardExecution>({
    key: keyWizardExecution,
    url: '/wizard/execution',
})

const keyWizardExecutions = (arg: string) => [`/wizard/executions`, arg]
export const useQueryWizardExecutions = createQuery<APIWizardExecutionResponse>({
    key: keyWizardExecutions,
    url: '/wizard/executions',
})

const keyWizardProducts = (arg: string) => [`/wizards/products`, arg]
export const useQueryWizardProducts = createQuery<APIWizardResponse>({
    key: keyWizardProducts,
    url: '/wizards/products',
})

export const keyUserWizards = (arg: string) => [`/user-wizards`, arg]
export const useQueryUserWizards = createQuery<APIUserWizardResponse>({
    key: keyUserWizards,
    url: '/user-wizards',
})

export const keyUserWizardExecutions = (arg: string) => [`/user-wizard/executions`, arg]
export const useQueryUserWizardExecutions = createQuery<APIWizardExecutionResponse>({
    key: keyUserWizardExecutions,
    url: '/user-wizard/executions',
})

export const keyWizardBundles = (arg: string) => [`/wizard/bundles`, arg]
export const useQueryWizardBundles = createQuery<APIUserBundleResponse>({
    key: keyWizardBundles,
    url: '/wizard/bundles',
})

export const keyWizardBundle = (arg: string) => [`/wizard/bundle`, arg]
export const useQueryWizardBundle = createQuery<IUserBundle>({
    key: keyWizardBundle,
    url: '/wizard/bundle',
})

const keyUserWizardBundles = (arg: string) => [`/user-wizard/bundles`, arg]
export const useQueryUserWizardBundles = createQuery<APIUserWizardBundleResponse>({
    key: keyUserWizardBundles,
    url: '/user-wizard/bundles',
})

const keyUserWizardBundle = (arg: string) => [`/user-wizard/bundle`, arg]
export const useQueryUserWizardBundle = createQuery<any>({
    key: keyUserWizardBundle,
    url: '/user-wizard/bundle',
})

export const keyFlowsForms = (arg: string) => [`/data-stores`, arg]
export const useQueryFlowsForms = createQuery<any>({
    key: keyFlowsForms,
    url: '/data-stores',
})

export const keyFlowsForm = (arg: string) => [`/data-store`, arg]
export const useQueryFlowsForm = createQuery<any>({
    key: keyFlowsForm,
    url: '/data-store',
})

const keyExecutionBlocks = (arg: string) => [`/wizard/execution/:executionId/blocks`, arg]
export const useQueryExecutionBlocks = createQuery<any>({
    key: keyExecutionBlocks,
    url: '/wizard/execution/:executionId/blocks',
})

const keyBlockResults = (arg: string) => [`/wizard/execution/:executionId/blocks/:blockId/results`, arg]
export const useQueryBlockResults = createQuery<any>({
    key: keyBlockResults,
    url: '/wizard/execution/:executionId/blocks/:blockId/results',
})

const keyExecutionSummary = (arg: string) => [`/wizard/execution/:executionId/summary`, arg]
export const useQueryExecutionSummary = createQuery<any>({
    key: keyExecutionSummary,
    url: '/wizard/execution/:executionId/summary',
})
